// LIBRARIES
import styled from "styled-components";

// MISC
import { BOXSHADOW, COLORS, FONTS, WIDTH } from "constants/styleVariables";

export const LockerStatisticElementContainer = styled.div`
  width: 100%;
  height: 160px;
  margin: 20px 0px;
  border-radius: 24px;
  background-color: #F5F5F5;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: pointer;
  @media (${WIDTH.tabletWidth}) {
    width: 600px;
  }
`;

export const LockerStatisticLeftSideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0 0 40px;
`;

export const LockerStatisticElementTitle = styled.div`
  color: ${COLORS.cornflowerBlue};
  font-size: 22px;
  font-weight: bold;
  font-family: ${FONTS.newsharp};
`;

export const LockerStatisticStatus = styled.div`
  color: ${COLORS.secondaryGray};
  font-size: 16px;
  font-weight: 600;
  font-family: ${FONTS.montserrat};
`;

export const LockerStatisticImageContainer = styled.div`
  width: 98px;
  height: 59px;
  background-color: #F5F5F5;
  margin-top: 11px;
`;

export const LockerStatisticRightSideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px 40px 20px 0;
  font-family: ${FONTS.newsharp};
`;

export const RightSideRow = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const RowTitle = styled.div`
  margin-right: 20px;
`;

export const RowValue = styled.div``;

export const ReportsValue = styled.div`
  color: ${COLORS.terraCotta};
  text-decoration: underline;
`;
